import script from "./CertificateRegistrationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificateRegistrationView.vue?vue&type=script&setup=true&lang=ts"

import "./CertificateRegistrationView.vue?vue&type=style&index=0&id=47d9e84e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d9e84e"]])

export default __exports__